export default "/img/pure-p-logo.png"